import type { LessonKind } from './api';

export const LESSON_KINDS: { value: LessonKind; label: string }[] = [
  { value: 'material', label: 'Material' },
  { value: 'guide', label: 'Guide' },
  { value: 'video', label: 'Video' },
  { value: 'link', label: 'Link' },
];

export const LESSON_KIND_LABEL: Record<LessonKind, string> = Object.fromEntries(
  LESSON_KINDS.map((k) => [k.value, k.label]),
) as Record<LessonKind, string>;
